import { checkResponse, errorHandler, getUrl } from '@/api/utils/http-helpers'
import axios from 'axios'

const MACHINE_SETTINGS_LOAD = 'MACHINE_SETTINGS_LOAD'
const MACHINE_SETTINGS_SAVE = 'MACHINE_SETTINGS_SAVE'
const START = 'START'
const END = 'END'
const SET_FIXED_MACHINE_SETTINGS = 'SET_FIXED_MACHINE_SETTINGS'

const initialState = {
  machinesettings: {},
  isLoading: false,
  isLoaded: false,
  isFixedMachineSettings: false
}

const state = { ...initialState }

// Getters
const getters = {
  machinesettings (state) {
    return state.machinesettings
  },
  fixedMachineSettings (state) {
    return state.isFixedMachineSettings
  }
}

// Actions
const actions = {
  async loadMachineSettings ({ commit }) {
    const url = getUrl(`/machine-settings`)
    commit('START')
    await axios
      .get(url)
      .then((response) => {
        checkResponse(response)
        commit('MACHINE_SETTINGS_LOAD', response.data)
        commit('END')
      })
      .catch(error => {
        errorHandler(error)
        // eslint-disable-next-line
        console.error(error)
      })
  },

  async updateMachineSettings ({ commit }, payload) {
    const url = getUrl(`/machine-settings`)
    commit('START')
    await axios
      .put(url, payload)
      .then((response) => {
        checkResponse(response)
        commit('MACHINE_SETTINGS_SAVE', response.data)
        commit('END')
      })
      .catch(error => {
        errorHandler(error)
        // eslint-disable-next-line
        console.error(error)
      })
  },

  async getFixedMachineSettings ({ commit }) {
    const url = getUrl(`/machine-settings/fixed`)
    commit('START')
    await axios
      .get(url)
      .then((response) => {
        checkResponse(response)
        commit('SET_FIXED_MACHINE_SETTINGS', response.data)
        commit('END')
      })
      .catch(error => {
        errorHandler(error)
        // eslint-disable-next-line
        console.error(error)
      })
  },

  async setFixedMachineSettings ({ commit }, payload) {
    const url = getUrl('/machine-settings/fixed')
    commit('START')
    await axios.put(url, {}, { params: { fixed: payload } })
      .then((response) => {
        checkResponse(response)
        commit('SET_FIXED_MACHINE_SETTINGS', response.data)
        commit('END')
      })
      .catch(error => {
        errorHandler(error)
        // eslint-disable-next-line
        console.error(error)
      })
  }
}

// Mutations
const mutations = {
  [START] (state) {
    state.isLoaded = false
    state.isLoading = true
  },

  [END] (state) {
    state.isLoading = false
    state.isLoaded = true
  },

  [MACHINE_SETTINGS_LOAD] (state, payload) {
    state.machinesettings = Object.assign({}, payload)
  },

  [MACHINE_SETTINGS_SAVE] (state, payload) {
    state.machinesettings = Object.assign({}, payload)
  },

  [SET_FIXED_MACHINE_SETTINGS] (state, payload) {
    state.isFixedMachineSettings = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
